export type ConjunctionObjectRole = "target" | "chaser";

const objectRoleLabels: Record<ConjunctionObjectRole, string> = {
  chaser: "Secondary",
  target: "Primary",
};

const matchCasing = (match: string, replacement: string) => {
  if (match === match.toUpperCase()) return replacement.toUpperCase();
  if (match[0] === match[0]?.toUpperCase()) return replacement;

  return replacement.toLowerCase();
};

const replaceCamelCaseRolePrefix = (value: string) =>
  value.replace(/\b(target|chaser)(?=[A-Z])/gi, (match) => {
    const role = match.toLowerCase() as ConjunctionObjectRole;

    return `${getObjectRoleLabel(role)} `;
  });

export const getObjectRoleLabel = (role: ConjunctionObjectRole) =>
  objectRoleLabels[role];

export const getObjectRoleLabelLower = (role: ConjunctionObjectRole) =>
  getObjectRoleLabel(role).toLowerCase();

export const replaceObjectRoleLabels = (value: string) =>
  replaceCamelCaseRolePrefix(value)
    .replace(/\btarget\b/gi, (match) => matchCasing(match, "Primary"))
    .replace(/\bchaser\b/gi, (match) => matchCasing(match, "Secondary"));
